var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleQuote2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.891,
    height: 52.774,
    viewBox: "0 0 59.891 52.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": " ",
    transform: "translate(-8170.234 -8235.521)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(8171.734 8237.021)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M8196.625,8267.238v14.223a5.336,5.336,0,0,1-5.336,5.337h-14.222a5.336,5.336,0,0,1-5.332-5.337V8254.8a17.769,17.769,0,0,1,17.776-17.773h.893a2.656,2.656,0,0,1,2.664,2.664v5.331a2.66,2.66,0,0,1-2.664,2.669h-.893a7.112,7.112,0,0,0-7.11,7.109v7.112h8.888A5.331,5.331,0,0,1,8196.625,8267.238Zm32,0v14.223a5.338,5.338,0,0,1-5.339,5.337h-14.217a5.336,5.336,0,0,1-5.335-5.337V8254.8a17.769,17.769,0,0,1,17.779-17.773h.887a2.655,2.655,0,0,1,2.664,2.664v5.331a2.659,2.659,0,0,1-2.664,2.669h-.887a7.115,7.115,0,0,0-7.113,7.109v7.112h8.886A5.332,5.332,0,0,1,8228.625,8267.238Z",
    transform: "translate(-8171.734 -8237.023)",
    fill: "none",
    stroke: "#de513e",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuote2);
export default __webpack_public_path__ + "static/media/doubleQuote2.cd26a427.svg";
export { ForwardRef as ReactComponent };